export const round = (value) => Math.round(value * 10) / 10;

export const displayNumber = (value) => round(value).toString().replace('.', ',');
